import { DETAIL_STOCK_OPNAME } from "../../constants/admin/masterdata/constants";

const initialState = {
  data: null,
  loading: true,
  error: null,

  downloading: false,
  downloadSuccess: false,
  downloadError: null,
  downloadData: null,
};

const detailStockOpnameReducer = (state = initialState, action) => {
  switch (action.type) {
    case DETAIL_STOCK_OPNAME.LOADING_DATA_DETAIL_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        loading: action.load,
      };

    case DETAIL_STOCK_OPNAME.GET_DATA_DETAIL_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
        error: null,
      };

    case DETAIL_STOCK_OPNAME.SET_DETAIL_STOCK_OPNAME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case DETAIL_STOCK_OPNAME.CLEAR_DETAIL_STOCK_OPNAME_ERROR:
      return {
        ...state,
        error: null,
      };

    case DETAIL_STOCK_OPNAME.LOADING_DOWNLOAD_STOCK_OPNAME:
      return {
        ...state,
        downloading: action.load,
      };

    case DETAIL_STOCK_OPNAME.DOWNLOAD_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        downloadSuccess: true,
        downloading: false,
        downloadError: null,
        downloadData: action.data,
      };

    case DETAIL_STOCK_OPNAME.DOWNLOAD_STOCK_OPNAME_ERROR:
      return {
        ...state,
        downloadError: action.error,
        downloading: false,
        downloadSuccess: false,
      };

    case DETAIL_STOCK_OPNAME.CLEAR_DOWNLOAD_STOCK_OPNAME:
      return {
        ...state,
        downloadSuccess: false,
        downloadError: null,
        downloadData: null,
      };

    default:
      return state;
  }
};

export default detailStockOpnameReducer;
